export default function WarningMsg({
  message,
  title,
  type = "warning",
}) {
  if (!message) {
    return null;
  }

  return (
    <div
      className={`warningError ${type}`}
      role={type === "error" ? "alert" : "status"}
    >
      {title && (
        <strong className="warningTitle">
          {title}
        </strong>
      )}

      <p>{message}</p>
    </div>
  );
}